import routes from '@/services/api/api'
import axios from 'axios'

/**
 * @description
 * Send request for logout tp logged user
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const logoutRequest = async function() {
    return new Promise((resolve, reject) => {
        axios({ 
            url: routes.LOGOUT_REQUEST,
            data: {},
            method: 'GET',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

/**
 * @description
 * Send request for reset user password
 * 
 * @param {oject} params
 * @return {Promise} success or error response
 */
const getLoginTokenRequest = async function(params) {
    return new Promise((resolve, reject) => {
        axios({
            url: routes.GET_LOGIN_TOKEN,
            params: {
                module_token: params.module_token,
            },
            method: 'GET',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
} // end function

export {
    getLoginTokenRequest, logoutRequest
}